import type { MultiSelectOptionGroup } from "@/components/ui/multi-select-filter";

const SUBSTATUS_ABBREVIATIONS: Record<string, string> = {
  BEHAVIOR: "BEH",
  MEDICAL: "MED",
  "BEH+MED": "BEH+MED",
};

export function getKennelStatusBadgeClass(status: string | null | undefined): string {
  if (!status) return "bg-transparent text-muted-foreground border border-border";
  const normalized = status.toUpperCase();
  const classes: Record<string, string> = {
    AVAILABLE: "bg-[hsl(var(--status-available)/0.12)] text-[hsl(var(--status-available))] border border-[hsl(var(--status-available)/0.3)]",
    UNAVAIL: "bg-[hsl(var(--status-unavailable)/0.12)] text-[hsl(var(--status-unavailable))] border border-[hsl(var(--status-unavailable)/0.3)]",
    UNAVAILABLE: "bg-[hsl(var(--status-unavailable)/0.12)] text-[hsl(var(--status-unavailable))] border border-[hsl(var(--status-unavailable)/0.3)]",
    STRAY_WAIT: "bg-[hsl(var(--status-stray-wait)/0.12)] text-[hsl(var(--status-stray-wait))] border border-[hsl(var(--status-stray-wait)/0.3)]",
    EVALUATION: "bg-[hsl(var(--status-evaluation)/0.12)] text-[hsl(var(--status-evaluation))] border border-[hsl(var(--status-evaluation)/0.3)]",
  };
  return classes[normalized] || "bg-transparent text-muted-foreground border border-border";
}

export function getKennelStatusLabel(status: string | null | undefined): string {
  if (!status) return "—";
  const normalized = status.toUpperCase();
  const labels: Record<string, string> = {
    AVAILABLE: "Available",
    UNAVAIL: "Unavailable",
    UNAVAILABLE: "Unavailable",
    STRAY_WAIT: "Stray Wait",
    EVALUATION: "Evaluation",
  };
  return labels[normalized] || status;
}

export function formatKennelStatus(status: string | null | undefined, substatus?: string | null): string {
  const label = getKennelStatusLabel(status);
  if (!substatus) return label;
  const abbr = SUBSTATUS_ABBREVIATIONS[substatus.toUpperCase()] ?? substatus;
  return `${label} (${abbr})`;
}

export const ADOPTION_LEVEL_BADGE_CLASS = "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400";
export const ADOPTION_LEVEL_EMPTY_BADGE_CLASS = "bg-transparent text-muted-foreground border border-border";

export const STATUS_TRACK_LABELS: Record<string, string> = {
  AVAILABLE: "Available",
  AVAILABLE_BEHAVIOR: "Available (BEH)",
  AVAILABLE_BEH_MED: "Available (BEH+MED)",
  UNAVAIL: "Unavailable",
  UNAVAIL_BEHAVIOR: "Unavailable (BEH)",
  UNAVAIL_MEDICAL: "Unavailable (MED)",
  UNAVAIL_BEH_MED: "Unavailable (BEH+MED)",
  STRAY_WAIT: "Stray Wait",
  EVALUATION: "Evaluation",
};

export const STATUS_TRACK_OPTION_GROUPS: MultiSelectOptionGroup[] = [
  {
    groupLabel: "Available",
    options: [
      { value: "AVAILABLE", label: "Available" },
      { value: "AVAILABLE_BEHAVIOR", label: "Available (BEH)" },
      { value: "AVAILABLE_BEH_MED", label: "Available (BEH+MED)" },
    ],
  },
  {
    groupLabel: "Unavailable",
    options: [
      { value: "UNAVAIL", label: "Unavailable" },
      { value: "UNAVAIL_BEHAVIOR", label: "Unavailable (BEH)" },
      { value: "UNAVAIL_MEDICAL", label: "Unavailable (MED)" },
      { value: "UNAVAIL_BEH_MED", label: "Unavailable (BEH+MED)" },
    ],
  },
  {
    groupLabel: "Other",
    options: [
      { value: "STRAY_WAIT", label: "Stray Wait" },
      { value: "EVALUATION", label: "Evaluation" },
    ],
  },
];
